module.exports = __webpack_public_path__ + "static/media/alena_thumb_even.ac12e454.webp";